import * as React from "react"
import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { batch } from "@preact/signals-react"

import { CommonFilters } from "@components"
import { endDate, isLoadingCommonFilters, sku, startDate } from "@signals"
import { elementsInLoading, skuDetailsScoresInLoading } from "./@signals"


export default function SkuDetailsFilters() {
	const [searchParams] = useSearchParams()
	const urlSku = searchParams.get("sku")
	
	useEffect(() => {
		if (urlSku) sku.value = parseInt(urlSku)
	}, [urlSku])

    useEffect(() => {
        if (sku.value?.length === 0)
            sku.value = null
    }, [])

    useEffect(() => {
        if (!!sku.value)
            isLoadingCommonFilters.value = true
    }, [sku.value, startDate.value, endDate.value])

	useEffect(() => {
		if (elementsInLoading.value.length < 1) batch(() => {
			isLoadingCommonFilters.value = false
		})
	}, [elementsInLoading.value.length])

	useEffect(() => {
		if (skuDetailsScoresInLoading.value.length < 1) batch(() => {
			isLoadingCommonFilters.value = false
		})
	}, [skuDetailsScoresInLoading.value.length])
    
	return <CommonFilters
		components={{
			sku: true, actions: false
		}}
		compProps={{
			sku: { grid: { md: 12 }, multiple: false, showAdornment: false },
		}}
	/>
}